export const PUSH = 'PUSH'
export const POP = 'POP'
export const REPLACE = 'REPLACE'

export default {
  PUSH,
  POP,
  REPLACE,
}
